<template>
  <div class="containerFull_worldCup">
    <FootballCupCommon
      :containerFullClassName="containerFullClassName"
      :defaultPath="defaultPath"
      :axiosBaseUrl="axiosBaseUrl"
      :sportCompetitionType="sportCompetitionType"
      :themeSeasonArr="themeSeasonArr"
    ></FootballCupCommon>
  </div>
</template>

<script>
// 足球 杯赛 世界杯 容器
import FootballCupCommon from './footballCup_common.vue'
import containerFull_data from '@mixins/football/cup/containerFull_FIFAWC_data'
export default {
  name: 'containerFull_worldCup',
  mixins: [containerFull_data],
  components: {
    FootballCupCommon,
  },
}
</script>
